export const root = "/";
export const about = "/about";
export const products = "/products";
export const contactUs = "/contact-us";
export const events = "/events";
